import { rem } from "@/styles/utils"
import { device_px, offline_page_padding, secondary } from "@/styles/variable"
import styled from "styled-components"

const { MAX_1919, MAX_1279, MAX_767 } = device_px
const { desktop, desktop_1280_1919, mobile_360_767, tablet_768_1279 } =
  offline_page_padding

export const Button = styled.button`
  padding: ${rem(20)} ${rem(10)};
  position: fixed;
  z-index: 100;
  bottom: ${rem(130)};
  right: ${rem(desktop)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${rem(9)};
  border-radius: ${rem(60)};
  border: 1px solid rgba(255, 225, 0, 0.3);
  background-color: #000;
  cursor: pointer;

  @media screen and (max-width: ${MAX_1919}) {
    right: ${rem(desktop_1280_1919)};
  }

  @media screen and (max-width: ${MAX_1279}) {
    bottom: ${rem(108)};
    right: ${rem(tablet_768_1279)};
  }

  @media screen and (max-width: ${MAX_767}) {
    bottom: ${rem(98)};
    right: calc(${rem(mobile_360_767)} + ${rem(11)});
  }
`

export const Text = styled.span`
  font-size: ${rem(20)};
  font-weight: 700;
  line-height: 160%;
  letter-spacing: ${rem(-0.6)};
  color: ${secondary.text};

  @media screen and (max-width: ${MAX_1279}) {
    font-size: ${rem(16)};
    letter-spacing: ${rem(-0.48)};
  }
`
